import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function AboutLiz({ compact = false }) {
  return (
    <section data-testid="about-liz-section" className="section relative overflow-hidden">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-5"
          >
            <div className="relative">
              <div className="aspect-square rounded-[2rem] overflow-hidden">
                <img
                  src="https://customer-assets-gfyr7b9c.emergentagent.net/job_mhfa-course-hub/artifacts/vuhywabe_1333x2000.jpg"
                  alt="Liz Milligan, MHFA Instructor"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 md:-right-10 bg-[#D88C76] text-[#FDFBF7] rounded-2xl p-5 max-w-[220px]">
                <div className="font-serif-display text-3xl leading-none">20+ yrs</div>
                <p className="mt-2 text-sm leading-snug">of training experience across a wide range of sectors and workplaces.</p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="lg:col-span-7"
          >
            <p className="eyebrow mb-4">Meet your instructor</p>
            <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.02] tracking-tight text-[#1E2A25]">
              Liz Milligan, <br />
              <span className="italic text-[#4A5D52]">accredited MHFA instructor.</span>
            </h2>

            <p className="mt-8 text-lg text-[#4A5D52] leading-relaxed max-w-2xl">
              Liz has been delivering 2-day Adult, Aware and Refresher MHFA courses for over 10 years —
              both in-house and for open course groups. Her wider training career spans over 20 years across
              multiple sectors, including many years supporting clients with a range of disabilities to maintain employment.
            </p>

            <p className="mt-4 text-lg text-[#4A5D52] leading-relaxed max-w-2xl">
              When more facilitators are needed, Liz works with a small pool of carefully selected,
              highly skilled co-facilitators — so every session stays intimate, considered and safe.
            </p>

            {!compact && (
              <div className="mt-10">
                <Link to="/about" data-testid="about-cta" className="link-underline">
                  Read Liz&apos;s full story <ArrowUpRight className="w-4 h-4" />
                </Link>
              </div>
            )}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
